import Heading from "shared/ui/typography/Heading";

const StandardProductListHeader = () => {
  return (
    <header className="gg-w-full lg:gg-grid lg:gg-gap-4 gg-grid-cols-12 gg-uppercase gg-mb-5 gg-hidden !gg-font-bold">
      <Heading
        headingLevel="h6"
        className="gg-col-span-7 lg:gg-col-span-7 xl:gg-col-span-7"
      >
        product
      </Heading>
      <Heading headingLevel="h6" className="gg-col-span-2 xl:gg-col-span-2">
        opties
      </Heading>
      <Heading headingLevel="h6" className="gg-col-span-2 xl:gg-col-span-2">
        aantal
      </Heading>
      <Heading headingLevel="h6" className="gg-col-span-1 xl:gg-col-span-1">
        prijs
      </Heading>
    </header>
  );
};
export default StandardProductListHeader;
